import { Component, OnInit, inject } from '@angular/core';

import {
    LoginResponse,
    LoginResponseHandlerService,
    LoginService2,
    LoginStoreService,
    MessageScope,
    NavigationService,
    SharedFeaturesApiService,
} from '@frontend/vanilla/core';

@Component({
    standalone: true,
    selector: 'vn-workflow',
    template: '',
})
export class WorkflowComponent implements OnInit {
    private api = inject(SharedFeaturesApiService);
    private loginResponseHandler = inject(LoginResponseHandlerService);
    private navigation = inject(NavigationService);
    private loginService = inject(LoginService2);
    private loginStore = inject(LoginStoreService);

    ngOnInit() {
        const data = {
            nativeClientSessionKey: this.navigation.location.search.get('nativeClientSessionKey'),
            nativeClientUsertoken: this.navigation.location.search.get('nativeClientUsertoken'),
        };

        this.api.post('pendingworkflow', data, { showSpinner: false, messageQueueScope: MessageScope.Login }).subscribe({
            next: (data: LoginResponse) => {
                this.loginStore.enablePostLoginCcbDelay();
                this.loginResponseHandler.handleResponse(data);
            },
            error: async () => await this.loginService.goTo({ forceReload: true, storeMessageQueue: true }),
        });
    }
}
